<template>
  <div>
    <div class="">
      <div class="m-auto h-full lg:px-16 md:xr-16 px-5 lg:ml-auto md:ml-auto">
        <img
          src="@/assets/images/coach/MicrosoftTeams-image (19) 1.png"
          alt=""
          class="w-full h-300 smh-auto h-full object-contain"
        />
        <!-- <h2 class="fsize24-16 font-bold pt-4 mb-2">
          Applications Close by 15th August 2022
        </h2>
        <p class="fsize18 font-bold clr-32325d mt-2 text-center">
          Save the Date and Time
        </p>
        <p class="fsize14 font-bold mb-4">
          Friday - 09:00 AM to 1:30 PM IST ( 19th Aug, 26th Aug, 2nd Sept, 9 th
          Sept and 16th Sept)
        </p> -->
        <!-- <h2 class="fsize24-16 font-bold pt-4 mb-2">
          Application close by {{ sessiondate | moment(" MMMM Do YYYY") }}
        </h2> -->
        <p class="fsize18 font-bold clr-32325d mt-2">
          Session Dates: {{ mysessiondate }}
        </p>
        <p class="fsize16 font-bold">
          {{ coachsession[0].day | moment("dddd ") }} - {{ mystartsession }} to
          {{ myendsession }}
        </p>
        <p class="fsize16 font-bold mb-4">
          Application closes by:
          {{ new Date(coachannounce[0].closeDate).toDateString() || "static" }}
        </p>
        <b-table class="row-clr" striped hover :items="handletime"></b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      handletime: [],
      items: [],
      sessiondate: "",
      mysessiondate: "",
      getmytime: "",
      myendsession: "",
      mystartsession: "",
    };
  },
  methods: {
    getdatefun(mydate) {
      let newmydate = new Date(mydate);
      // return newmydate.toLocaleDateString();
      let month = newmydate.getMonth();
      let year = newmydate.getFullYear();
      let date = newmydate.getDate();

      let fixdate = date + "/" + month + "/" + year;
      return fixdate;
    },
    getMysession(mydate) {
      let newmydate = new Date(mydate);
      // return newmydate.toLocaleDateString();
      let month = newmydate.getMonth();
      let year = newmydate.getFullYear();
      let date = newmydate.getDate();
      let getmonth = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "Decembe",
      ];
      let fixdate = date + "th" + " " + getmonth[month] + " ,";
      return fixdate;
    },
    getDay(date) {
      let myday = new Date(date);
      let getmyday = myday.getDay();
      let weekdays = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      return weekdays[getmyday];
    },
  },
  async mounted() {
    this.$store.dispatch("coach/getcoachtable");
    this.$store.dispatch("coach/getcoachannonce");
    await this.$store.dispatch("coach/GetSession");
    let sessiondata = this.coachsession.length - 1;
    this.sessiondate = this.coachsession[sessiondata].date;

    this.mystartsession = this.coachsession[0].starttime;
    this.myendsession = this.coachsession[0].endtime;
    // console.log(this.coachsession);
    this.coachsession.forEach((y) => {
      this.handletime.push({
        date: new Date(y.date).toLocaleDateString("en-IN", {
          year: "numeric",
          day: "numeric",
          month: "numeric",
        }),
        day: this.getDay(y.date),
        start: y.starttime,
        end: y.endtime,
      });
      this.mysessiondate = this.mysessiondate + " " + this.getMysession(y.date);
    });
    // console.log(this.mysessiondate, "sessiondatesessiondate");

    // console.log("coatch datatta", this.coachtable);
    // console.log("coatch annnnn", this.coachannounce);
    // console.log("coatch annnnn", this.coachannounce[0].title);
  },
  computed: {
    ...mapState("coach", {
      coachsession: "coachsession",
    }),
    ...mapState("coach", {
      coachtable: "coachtable",
    }),
    ...mapState("coach", {
      coachannounce: "coachannounce",
    }),
  },
};
</script>
